import { api } from "../helpers";

const prefix = "/cards";

export const getCardsList = (param, token) => {
	// remove empty string values
	for (const name in param) {
		const isEmptyString = param[name] === "";
		const isUndefined = param[name] === undefined;

		if (isEmptyString || isUndefined) {
			delete param[name];
		}
	}

	return api(`${prefix}`, "GET", undefined, param, token);
};

export const getCard = (param, token) => {
	const { id, ...rest } = param;

	return api(`${prefix}/${id}`, "GET", undefined, rest, token);
};

export const postCard = (payload, token) => {
	return api(`${prefix}/create`, "POST", payload, undefined, token);
};

export const postManyCards = (payload, token) => {
	return api(`${prefix}/create-many`, "POST", payload, undefined, token);
};

export const updateCard = (payload, token) => {
	return api(`${prefix}/update`, "PUT", payload, undefined, token);
};
